import React, {useCallback, useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router";
import {useTranslation} from 'react-i18next';
import {AxiosError} from 'axios';
import {Location} from 'history';
import client from 'lib/CommonApi/client';
import stringUtils from 'common/stringUtils';
import {callAlertWeb} from 'common/appInterface';
import PullToRefresh from 'react-simple-pull-to-refresh';

const ApprovalList: React.FC<CardTabProps> = ({ cardInfo, swiperIndex, swiperTabChangeEventHandle }) => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;
  /** Navigate */
  const navigate = useNavigate();
  /** 다국어처리 */
  const { t } = useTranslation();

  const [approvalList, setApprovalList] = useState<ApprovalInfo[]>([]);

  /** 승인내역검색 */
  const callApprovalFirstSearch = useCallback(async () => {
    await client.get("/api/app/approval/selectApprovalList", { params: { ...location.state.query, currentPage: "1", alternativeCardNo: cardInfo.alternativeCardNo, rowsPerPage : 5 }}).then((response) => {
      let result = response.data.response;
      // console.log(result);
      setApprovalList(result);
    }).catch((e: AxiosError) => {
      callAlertWeb("ERROR", "99", e.message);
    });
  }, [location, cardInfo]);

  /** 승인내역 상세 */
  const clickDetail = useCallback((tradeApprovalSeq: string, tradeDate: string) => {
    // setApprovalDetailProps((value) => ({ ...value, tradeApprovalSeq: tradeApprovalSeq, tradeDate: tradeDate }));
    // footerShowEventWeb("N");
    // setDetail(true);
    navigate("/approval/detail", { state: { query: location.state.query, approval: { tradeApprovalSeq : tradeApprovalSeq, tradeDate: tradeDate }, from: location.pathname, swiperIndex: swiperIndex, tabIndex: "1" }})
  }, [location, navigate, swiperIndex]);

  // 최초실행
  useEffect(() => {
    if(["1", "3"].includes(localStorage.getItem('menuCode') as string) || ["1", "3", null, undefined, ""].includes(location.state.query.menuCode)){
      callApprovalFirstSearch();
    }
    // console.log(alternativeCardNo);

    // Swiper Height Resize
    swiperTabChangeEventHandle();

    // 최초한번실행 useEffect() Warning 제거
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PullToRefresh onRefresh={() => new Promise<void>((resolve) => { callApprovalFirstSearch(); setTimeout(resolve, 1000); })} pullingContent={<></>}>
      <>
        <section className="contents myPageSetting">
          <div className="inner">
            <div className="settingListWrap clfix">
              <dl className="settingList">
                {approvalList.length === 0 &&
                  <dt><span className="day">{t("TRAN01.nouse")}</span></dt>
                }
                {approvalList.map((item) => 
                  <dd key={item.tradeApprovalSeq}>
                    <button type="button" onClick={() => clickDetail(item.tradeApprovalSeq, item.tradeDate)}>
                      <span className="spot">{item.merchantName}</span>
                      <p className="date">{item.approvalDate.substring(0, 4) +"-"+ item.approvalDate.substring(4, 6) + "-" + item.approvalDate.substring(6, 8) + " " + item.approvalTime.substring(0, 2) + ":" + item.approvalTime.substring(2,4)} {t(`TRAN02.auth.${item.salesKindDivisionCode}`)}</p>
                      <span className={item.salesKindDivisionCode === '05' ? "place out": "place"}>{item.salesKindDivisionCode === '05' ? stringUtils.moneyFormat(item.cardApprovalAmount) : '+' + stringUtils.moneyFormat(item.cardApprovalAmount)} KRW</span>
                    </button>
                  </dd>
                )}
              </dl>
            </div>
          </div>
        </section>
        <div className="btnArea">
          <div className="btnWrapTy01 mgb70">
            <button type="button" className="btnPrimaryTy01" onClick={() => navigate("/approval", { state: { query: location.state.query, info: { alternativeCardNo: cardInfo.alternativeCardNo }, from: location.pathname, swiperIndex: swiperIndex, tabIndex: "1" }})}><span>+ {t("TRAN01.button04")}</span></button>
          </div>
        </div>
      </>
    </PullToRefresh>
  );
};

export default ApprovalList;